import { redirect } from "@/router";

export const Loader = () => redirect("/billing/dues-management/suspensions-and-terminations/suspensions");
